import css from "@styled-system/css";
import styled from "styled-components";
import { theme } from "styles/theme";

export const ReactDatePickerStyles = styled.div`
  ${css({
    ".react-datepicker__close-icon": {
      top: "4.5px",
      right: "3.5rem",
      "&::after": {
        bg: "neutral.300",
      },
    },
    "&.datetime-picker .react-datepicker": {
      ".react-datepicker__navigation--next": {
        right: "11rem",
      },
    },

    ".react-datepicker": {
      display: "flex",
      fontSize: "1.6rem",
      border: 0,
      p: "2.4rem",
      fontFamily: "NeometricRegular",
      borderRadius: "8px",
      boxShadow:
        "0px 2px 4px rgba(0, 0, 0, 0.04), 0px 8px 16px rgba(0, 0, 0, 0.16)",
      ".react-datepicker__triangle": {
        display: "none",
        left: "-8rem !important",
        // "&::after": {
        //   borderColor: "white",
        // },
      },
      ".react-datepicker__time .react-datepicker__time-list .react-datepicker__time-list-item":
        {
          fontSize: "1.4rem",
          color: "neutral.600",
          "&.react-datepicker__time-list-item--selected, &.react-datepicker__time-list-item--selected:hover":
            {
              bg: "primary.500",
            },
        },
      ".react-datepicker__navigation": {
        px: "2.6rem",
        top: "0.4rem",
        ".react-datepicker__navigation-icon": {
          "&::before": {
            borderColor: "neutral.900",
            borderWidth: "2px 2px 0 0",
            height: "7px",
            width: "7px",
          },
        },
      },
      ".react-datepicker__header.react-datepicker__header--custom": {
        ".react-datepicker__navigation": {
          padding: 0,
          top: 0,
          ".react-datepicker__navigation-icon": {
            "&::before": {
              borderColor: "neutral.900",
            },
          },
        },
      },
      ".react-datepicker__header": {
        bg: "white",
        borderBottom: 0,
        ".react-datepicker__current-month, .react-datepicker-time__header": {
          fontSize: "1.6rem",
          fontWeight: "500 !important",
          color: theme.colors.neutral[900],
        },
        "&.react-datepicker__header--custom": {
          paddingTop: 0,
        },
      },
      ".react-datepicker__month.react-datepicker__monthPicker": {
        margin: 0,
        ".react-datepicker__month-wrapper": {
          display: "flex",
          gap: "0.7rem",
          "&:not(:first-child)": {
            marginTop: "0.7rem",
          },
          ".react-datepicker__month-text": {
            width: "7rem",
            height: "3.2rem",
            bg: "white",
            border: "1px solid",
            borderColor: "neutral.300",
            borderRadius: "0.4rem",
            margin: 0,
            display: "inline-flex",
            justifyContent: "center",
            alignItems: "center",
            fontSize: "1.2rem",
            fontWeight: 500,
            lineHeight: "2rem",
            color: "neutral.700",
            "&.react-datepicker__month--disabled": {
              color: "neutral.300",
            },
            "&.react-datepicker__month--selected": {
              color: "white",
              bg: "primary.500",
              borderColor: "primary.500",
            },
            "&.react-datepicker__month-text--keyboard-selected": {
              color: "white",
              bg: "primary.500",
              borderColor: "primary.500",
            },
            "&:not(.react-datepicker__month--disabled):hover": {
              color: "white",
              bg: "primary.500",
              borderColor: "primary.500",
            },
          },
        },
      },
      ".react-datepicker__header.react-datepicker-year-header": {
        margin: "0 0 2rem",
        padding: 0,
        fontSize: "1.6rem",
        fontWeight: "500 !important",
        color: theme.colors.neutral[900],
      },
      ".react-datepicker__year--container": {
        ".react-datepicker__year": {
          margin: 0,
          ".react-datepicker__year-wrapper": {
            maxWidth: "none",
            display: "grid",
            gridTemplateColumns: "repeat(3, 1fr)",
            gridTemplateRows: "repeat(4, 1fr)",
            gap: "0.7rem",
            ".react-datepicker__year-text": {
              width: "7rem",
              height: "3.2rem",
              // background: theme.colors.white,
              border: `1px solid ${theme.colors.neutral[300]}`,
              borderRadius: "0.4rem",
              margin: 0,
              display: "inline-flex",
              justifyContent: "center",
              alignItems: "center",
              fontSize: "1.2rem",
              fontWeight: 500,
              lineHeight: "2rem",
              color: theme.colors.neutral[700],
              "&.react-datepicker__year-text--disabled": {
                color: theme.colors.neutral[300],
                borderColor: theme.colors.neutral[300],
              },
              "&.react-datepicker__year--selected": {
                color: "white",
                bg: "primary.500",
                borderColor: "primary.500",
              },
              "&.react-datepicker__year-text--keyboard-selected": {
                color: "white",
                bg: "primary.500",
                borderColor: "primary.500",
              },
              "&.react-datepicker__year-text--selected": {
                color: "white",
                bg: "primary.500",
                borderColor: "primary.500",
              },
              "&:not(.react-datepicker__year-text--disabled):hover": {
                color: "white",
                bg: "primary.500",
                borderColor: "primary.500",
              },
            },
          },
        },
      },
      ".react-datepicker__day": {
        p: "initial",
        width: "3.2rem",
        borderRadius: 0,
        fontWeight: 500,
        height: "3.2rem",
        color: "neutral.600",
        alignItems: "center",
        display: "inline-flex",
        justifyContent: "center",
        "&.react-calendar__year-view__months__month, &.react-calendar__decade-view__years__year, &.react-calendar__century-view__decades__decade":
          {
            width: "100%",
            borderRadius: "4px",
            border: "1px solid",
            borderColor: "neutral.300",
            "&react-datepicker__day--today": {
              borderColor: "primary.500",
            },
          },
        "&.react-calendar__month-view__days__day--weekend": {
          color: "black",
        },
      },
      ".react-datepicker__day--today": {
        background: "white",
        // border: `1px solid ${theme.colors.primary[500]}`,
        // color: theme.colors.primary[500],
        border: "1px solid",
        borderColor: "secondary.700",
        color: "primary.500",
      },
      ".react-datepicker__day.react-datepicker__day--disabled": {
        color: theme.colors.neutral[300],
      },
      ".react-datepicker__day--outside-month": {
        color: theme.colors.neutral[300],
        "&.react-datepicker__day--today": {
          borderColor: theme.colors.secondary[700],
          color: theme.colors.neutral[300],
        },
      },
      ".react-datepicker__day--selected": {
        color: "white",
        // background: theme.colors.primary[500],
        bg: "secondary.700",
      },
      ".react-datepicker__day--keyboard-selected": {
        backgroundColor: "white",
        "&:hover": {
          // not a theme color, it's coming from library
          backgroundColor: "#f0f0f0",
        },
      },
      ".react-datepicker__day-names": {
        mb: 0,
        mt: "2.4rem",
        // bg: "neutral.100",
        borderRadius: "4px",
        ".react-datepicker__day-name": {
          width: "3.2rem",
          height: "3.2rem",
          color: "neutral.400",
          alignItems: "center",
          display: "inline-flex",
          justifyContent: "center",
          backgroundColor: "neutral.50",
        },
      },
      ".react-datepicker__wrapper": {
        pl: "1.2rem",
        borderRadius: "4px",
        borderColor: "neutral.300",

        "input, span": {
          color: "black",
          fontSize: "1.4rem",
          fontFamily: "NeometricRegular",
          background: "transparent",
        },
        input: {
          "::placeholder": {
            color: "neutral.300",
          },
          "&:hover": {
            borderColor: "primary.300",
          },
          "&:focus": {
            outline: 0,
            background: "transparent",
            borderColor: "primary.700",
          },
        },
        span: {
          fontSize: "1.35rem",
        },
        ".react-datepicker__calendar-button": {
          mr: "1rem",
          color: "neutral.300",
        },
        "&.input-error": {
          borderColor: "red.500",
        },
        "&:disabled": {
          bg: "white",
          color: "neutral.300",
          "&:hover": {
            borderColor: "neutral.300",
          },
        },
      },
    },
  })}
`;
